import { useTranslation } from "react-i18next";
import { FEATURE_KEYS } from "../../config/featureKeys";

// اختيار الميزات المفتوحة للشركة لحظة إنشائها (الافتراضي: مغلقة، والأساس حضور وإجازات فقط).
export const CompanyFeaturePicker = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="sm:col-span-3">
      <p className="label-xs mb-2">{t("platform.featuresTitle")}</p>
      <p className="mb-3 text-[11px] text-muted-foreground">{t("platform.featuresHint")}</p>
      <div className="flex flex-wrap gap-2" data-testid="company-features">
        {FEATURE_KEYS.map((key) => {
          const on = Boolean(value[key]);
          return (
            <button
              key={key}
              type="button"
              data-testid={`company-feature-${key}`}
              onClick={() => onChange({ ...value, [key]: !on })}
              className={`rounded-2xl border px-3 py-2 text-xs font-bold transition-[box-shadow,color] duration-300 ${
                on ? "border-primary/50 text-primary shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
              }`}
            >
              {t(`features.names.${key}`, { defaultValue: key })}
            </button>
          );
        })}
      </div>
    </div>
  );
};
